import { Injectable } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CUSTOM_STRATEGY_GLOBAL_INDEX } from '../shared/constants';
import { App as CapacitorApp } from '@capacitor/app';
import { investmentFragmentId } from '../pages/summary/summary.component';
import { TranslateService } from '@ngx-translate/core';

function isNavigationEnd(event: Event): event is NavigationEnd {
  return event instanceof NavigationEnd;
}

/**
 * fixme -
 * This service is workaround of routing in native apps after Capacitor
 * sometimes when using back arrow on Android/Capacitor app, old component was still rendered with new, uninitiated component below https://github.com/angular/angular/issues/22509
 * or rendered empty template without data with high latency or not displaying at all
 */
@Injectable()
export class CustomRoutingService {
  private routeHistory: string[] = [];

  public constructor(
    private router: Router,
    private translate: TranslateService,
  ) { }

  public startLoggingHistory(): void {
    this.routeHistory.length = 0;
    this.router.events
      .pipe(filter(isNavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if(
          // ignored or duplicit routes
          this.routeHistory[this.routeHistory.length - 1] !== event.urlAfterRedirects &&
          !(this.routeHistory[this.routeHistory.length - 1]
          && this.routeHistory[this.routeHistory.length - 1].startsWith('/investment-detail')) &&
          event.urlAfterRedirects !== ('/strategy/new/' + CUSTOM_STRATEGY_GLOBAL_INDEX.modelStrategyId)
        ) {
          this.routeHistory.push(event.urlAfterRedirects);
        }
    });

    CapacitorApp.addListener('backButton', () => {
      if((this.router.url.startsWith('/summary') || this.router.url.startsWith('/login')) && confirm(this.translate.instant('global.closeAppConfirm'))) {
         CapacitorApp.exitApp()
      } else {
        this.routeBack();
      }
    });
  }

  private get previousUrl(): string {
    return this.routeHistory[this.routeHistory.length - 2] ?? '';
  }

  public routeBack(): void {
    if(this.routeHistory.length <=1) {
      // summary as homepage/fallback
      this.routeHistory.length = 0;
      this.router.navigate(['/summary']);
    } else if (this.previousUrl.includes(investmentFragmentId)) {
      this.routeHistory.length = 0;
      this.router.navigate(['/summary'], {fragment: investmentFragmentId});
    } else {
      this.router.navigate([this.previousUrl]);
      this.routeHistory.pop();
      this.routeHistory.pop();
    }
  }
}